import React, { useEffect ,useRef,useState} from 'react';
import UseLangLstQuery from 'Apis/LangTxtInqApi';
import { useNavigate ,useLocation } from "react-router-dom";
import 'Assets/css/BlckMemb.css';
import { Helmet } from 'react-helmet-async';
import LnchStrtApi from 'Apis/LnchStrtApi';
import GameSvcLinkApi from 'Apis/GameSvcLinkApi';
import IsMntnInqApi from 'Apis/IsMntnInqApi';
import GameLnchMdalUi from 'Utils/GameLnchMdalUi';
import ApiResultModal from 'Components/ApiResultModal';
import { fetchAdPayload, getKstTimestamp, useGtm } from 'hooks/useGtm';

declare global {
    interface Window {
        fbq?: (...args: any[]) => void;
    }
}
const GameLnchStrtUi = () => {
    const hasStartedRef = useRef(false);
    const { push: gtmPush } = useGtm();
    const location = useLocation(); 
    const navigate = useNavigate();
    const searchParams = new URLSearchParams(location.search);
    const getGameSvcCd = searchParams.get("gameSvcCd") || (location.state as any)?.gameSvcCd || "BBO";
    const getMeltSetYn = searchParams.get("mltSetYn") || (location.state as any)?.mltSetYn || "N";
    const {isLoading,error,data: langData}:any = UseLangLstQuery();
    const [showLaunchModal, setShowLaunchModal] = useState(false);
    const [launchingState, setLaunchingState] = useState(true);
    const [resultModalOpen, setResultModalOpen] = useState(false);
    const [resultModalMessage, setResultModalMessage] = useState("");
    const [modalAction, setModalAction] = useState<(() => void) | null>(null);
    const [launchCountdown, setLaunchCountdown] = useState<number | null>(null);

    const openResultModal = (message: string,onClose?: () => void) => {
        setResultModalMessage(message);
        setModalAction(() => onClose || null);
        setResultModalOpen(true);
    };

    const closeResultModal = () => {
        setResultModalOpen(false);
        const action = modalAction;
        setModalAction(null);
        if (action) action();
    };

    const gameSvcCd = (location.state as any)?.gameSvcCd || new URLSearchParams(location.search).get("gameSvcCd") || "BBO";
    const meltSetYn = (location.state as any)?.mltSetYn || new URLSearchParams(location.search).get("mltSetYn") || "N";

    useEffect(() => {
        if (launchCountdown === null || launchCountdown <= 0) {
            return;
        }

        const timerId = window.setInterval(() => {
            setLaunchCountdown((prev) => {
                if (prev === null || prev <= 1) {
                    window.clearInterval(timerId);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => {
            window.clearInterval(timerId);
        };
    }, [launchCountdown]);

    useEffect(() => {
        if (launchCountdown === 0) {
            navigate("/", { replace: true });
        }
    }, [launchCountdown, navigate]);

    const LnchStrtFunc = async (targetGameSvcCd:string) => {
        try {
            const firstResp = await LnchStrtApi(targetGameSvcCd,meltSetYn);

            switch(firstResp.apiHdr.code) {
                case "GAME0000":
                    const tsKst = getKstTimestamp();
                    const adPayload = await fetchAdPayload( targetGameSvcCd||'BBO');
                    setLaunchCountdown(10);
                    if (window.fbq) {
                        window.fbq('trackCustom', 'BBO_FB_Game_Start');
                    }
                    try {

                        gtmPush('BBO_GA_Game_Start', {
                            ts: tsKst,
                            ...adPayload,
                        });
                    } catch (gtmErr) {
                        if (typeof window !== 'undefined') {
                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push({
                                event: 'BBO_GA_Game_Start',
                                ts: tsKst,
                                ...adPayload,
                            });
                        }
                    }
                    setShowLaunchModal(true);
                    window.location.href = firstResp.apiBody.lnchScheme;

                break;

                case "GAME3101":
                    await GameSvcLinkApi(targetGameSvcCd);
                    const retryResp = await LnchStrtApi(targetGameSvcCd,meltSetYn);
                    if(retryResp.apiHdr.code === "GAME0000") {
                        const tsKst = getKstTimestamp();
                        const adPayload = await fetchAdPayload( targetGameSvcCd||'BBO');
                        if (window.fbq) {
                        window.fbq('trackCustom', 'BBO_FB_Game_Start');
                    }
                    try {

                        gtmPush('BBO_GA_Game_Start', {
                            ts: tsKst,
                            ...adPayload,
                        });
                    } catch (gtmErr) {
                        if (typeof window !== 'undefined') {
                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push({
                                event: 'BBO_GA_Game_Start',
                                ts: tsKst,
                                ...adPayload,
                            });
                        }
                    }
                        setShowLaunchModal(true);
                        window.location.href = retryResp.apiBody.lnchScheme;
                    } else {
                        openResultModal(`${retryResp.apiHdr.msg}`);
                    }
                break;
                case "GAME3112" : 
                    openResultModal(`${langData?.COMM_MAIN_MNTN_MAIN_LBL_00 || ''}`, () => {
                        navigate("/", { replace: true });
                    });
                break;
                default:
                    openResultModal(`${firstResp.apiHdr.msg}`);
                break;
            }
        } catch (error:any) {
            if (error?.code === "ATHN2303") {
                return;
            }
            console.error('게임 실행 중 오류:', error);
            openResultModal(langData?.GAME_LAUNCH_ERROR || "게임 실행 중 오류가 발생했습니다.");
        } finally {
            setLaunchingState(false);
        }
    }

    const startLaunchWithMntnCheck = async (targetGameSvcCd: string) => {
        if (!targetGameSvcCd) {
            setLaunchingState(false);
            return;
        }

        setLaunchingState(true);
        try {
            const mntnResp = await IsMntnInqApi(targetGameSvcCd);
            const mntnData = mntnResp?.apiBody || [];
            const currentMntn = mntnData?.find((item: any) => item.gameSvcCd?.toUpperCase() === targetGameSvcCd?.toUpperCase());
            const isMaintenance = !!currentMntn && currentMntn.isMntn === "Y";

            if (isMaintenance) {
                openResultModal(
                    `${langData?.COMM_MAIN_MNTN_MAIN_LBL_00 || ''}\n${langData?.COMM_MAIN_MNTN_TIME_LBL_STRT_00 || ''} ${currentMntn?.mntnStrtDtime || '-'}\n${langData?.COMM_MAIN_MNTN_TIME_LBL_STOP_00 || ''} ${currentMntn?.mntnStopDtime || '-'}`
                ,()=> {
                    navigate("/", { replace: true });
                });
                setLaunchingState(false);
                return;
            }

            await LnchStrtFunc(targetGameSvcCd);
        } catch (error) {
            console.error('점검 확인 중 오류:', error);
            openResultModal(langData?.GAME_LAUNCH_ERROR || "게임 실행 중 오류가 발생했습니다.", () => {
                navigate("/", { replace: true });
            });
            setLaunchingState(false);
        }
    };

    useEffect(()=>{
        if (hasStartedRef.current) {
            return;
        }
        if (isLoading || !langData) {
            return;
        }
        if(!gameSvcCd) {
            setLaunchingState(false);
            // navigate("/", { replace: true });
            return;
        }
        hasStartedRef.current = true;
        startLaunchWithMntnCheck(gameSvcCd);
    },[gameSvcCd, isLoading, langData]);

    return(
        <>
            <ApiResultModal
                open={resultModalOpen}
                message={resultModalMessage}
                onClose={closeResultModal}
                confirmText={langData&&langData.COMM_MAIN_CHK_MAIN_BTN_00}
            />
            <div className='loginInputWrap'>
                <Helmet>
                    <title>{process.env.REACT_APP_TITLE_PREFIX} GameLogin</title>
                </Helmet>
                <h2 style={{color:"#fff"}}>{langData?.GAME_LOGIN_LNCH_CHK_MSG_00}</h2>
                <p style={{ color: "#fff", marginTop: "8px" }}>
                    {launchCountdown !== null && launchCountdown > 0 ? `${launchCountdown} ${langData?.GAME_LOGIN_MOVING_MAIN_MSG_00} ` : ""}
                </p>
            </div>
            {/* {showLaunchModal && (
                // <GameLnchMdalUi gameMainPageInfoState={null} onClose={() => setShowLaunchModal(false)} langData={langData} />
            )} */}
        </>
    )
}

export default GameLnchStrtUi;